import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/_components/ui/tooltip'
import { AlertTriangle } from 'lucide-react'

interface AtomicMismatchProps {
  differs: boolean
  display: string
  tooltip: string
}

export const AtomicMismatch = ({ differs, display, tooltip }: AtomicMismatchProps) => {
  if (!differs) return <span>{display}</span>
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex cursor-default items-center gap-1 text-aux-red-danger-8">
            {display}
            <AlertTriangle className="h-3.5 w-3.5" />
          </span>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
